import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  Select,
  message,

  Spin,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import CropperUploder from "../../imageUploader/CropperUploder";
import * as csc from "country-state-city";
import {
  createSurveyor,
  updateSurveyor,
} from "../../../api/CommonRequest";

import { State, City } from "country-state-city";

const { Option } = Select;

const CreateSurveyor = ({ editData }) => {
  console.log(editData,"editData");
  
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [fileList, setFileList] = useState([]);
  const [imgPre, setImgPre] = useState("");
  const [btnLoader, setBtnLoader] = useState();
  const [loader, setLoader] = useState(false);

  // New state for dynamic dropdowns

  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [stateSearchValue, setStateSearchValue] = useState("");
  const [citySearchValue, setCitySearchValue] = useState("");
  useEffect(() => {
    setStates(State.getStatesOfCountry("IN"));
  }, []);
  useEffect(() => {
const initailSurveyorCall=()=>{
        const { state, district, city,address } = editData?.roleDetails;
        const { name, phone, email,profileImage } = editData;
        form.setFieldsValue({
          name,
          phone,
          email,
          address,
          state,
          district,
          city,
        });

        setSelectedStates(
          state
            .map((stateCode) => states.find((s) => s.isoCode === stateCode))
            .filter(Boolean)
        );

        setSelectedDistrict(
          district.map((districtName) => ({
            name: districtName.split("-")[1],
            stateCode: districtName.split("-")[0],
          }))
        );

        setSelectedCities(
          city.map((cityName) => ({
            name: cityName.split("-")[1],
            stateCode: cityName.split("-")[0],
          }))
        );

        // Update cities based on selected states
        const allCities = state.flatMap((stateCode) =>
          City.getCitiesOfState("IN", stateCode).map((city) => ({
            ...city,
            stateCode: stateCode,
          }))
        );
        setCities(allCities);

        if (profileImage) {
          setFileList([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url:profileImage,
            },
          ]);
          setImgPre(profileImage);
        }
      }
        if(editData){
          initailSurveyorCall()
        }
      },

      
    
   [editData, form]);

  const handleStateChange = (value) => {
    const selectedStateObjects = states.filter((state) =>
      value.includes(state.isoCode)
    );
    setSelectedStates(selectedStateObjects);
    const allCities = selectedStateObjects.flatMap((state) =>
      City.getCitiesOfState("IN", state.isoCode).map((city) => ({
        ...city,
        stateCode: state.isoCode,
      }))
    );
    setCities(allCities);
    setSelectedCities([]);
  };

  const handleDistrictChange = (value) => {
    form.setFieldsValue({ city: undefined });
    const stateName = form.getFieldValue("state");
    const stateObj = states.find((state) => state.name === stateName);
    if (stateObj) {
      const stateCities = csc.City.getCitiesOfState("IN", stateObj.isoCode);
      const filteredCities = stateCities.filter(
        (city) => city.name.toLowerCase() === value.toLowerCase()
      );
      setCities(filteredCities);
    }
  };

  // ------------------ PROFILE IMAGE---------

  const handleDataFromChild = (data, base64Img) => {
    const imgSelected = [
      {
        uid: "-1",
        name: "image.png",
        status: data ? "done" : "",
        url: base64Img,
        thumbUrl: base64Img,
        originFileObj: data,
      },
    ];
    setFileList(imgSelected);
    setImgPre(base64Img);
  };

  const onChange = ({ fileList: newFileList }) => {
    if (newFileList[0]?.status) {
      newFileList[0].status = "done";
    }
    setFileList(newFileList);
    setImgPre(
      newFileList[0]?.originFileObj
        ? URL.createObjectURL(newFileList[0]?.originFileObj)
        : ""
    );
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const uploderButton = (
    <div className="flex flex-col items-center justify-center w-full h-[150px] border border-dashed border-[#A3BBFF] rounded-md">
      <PlusOutlined style={{ fontSize: "32px", color: "#A3BBFF" }} />
      <p className="mt-2 text-[18px] font-medium text-[#313131]">Upload</p>
    </div>
  );

  const onFinish = async (values) => {
    console.log(values, "values");

    try {
      setBtnLoader(true);
      const formData = new FormData();

      // Log the form values for debugging
      // console.log("Form values:", values);

      // Add basic fields
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("password", values.password);
      formData.append("phone", values.phone || "");
      formData.append("address", values.address || "");
      formData.append("bankName", values.bankName || "");
      formData.append("accountNumber", values.accountNumber || "");
      formData.append("accountHolderName", values.accountHolderName || "");
      formData.append("ifscCode", values.ifscCode || "");
      formData.append("branchName", values.branchName || "");
      values.state.forEach((state) => formData.append("state[]", state));
      values.district.forEach((district) =>
        formData.append("district[]", district)
      );
      values.city.forEach((city) => formData.append("city[]", city));

      if (fileList[0]?.originFileObj) {
        formData.append("profileImg", fileList[0].originFileObj, "profileImg");
      }

      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }

      const { data } = await (editData
        ? updateSurveyor(editData, formData)
        : createSurveyor(formData));

      console.log(data, "data");

      if (data.success) {
        message.success("Surveyor created successfully");
        navigate("/surveyor-list");
      } else if (data.update) {
        message.success("Surveyor Updated successfully");
        navigate("/surveyor-list");
      } else {
        message.error(data.message);
      }
    } catch (error) {
      console.error("Error creating surveyor:", error);

      message.error("Failed to create surveyor");
    } finally {
      setBtnLoader(false);
    }
  };

  const filterStates = (input, option) => option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;

  const filterCities = (input, option) => option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;

  const handleStateSearch = (value) => {
    setStateSearchValue(value);
  };

  const handleCitySearch = (value) => {
    setCitySearchValue(value);
  };
  // Group cities by state
  const groupedCities = cities.reduce((acc, city) => {
    if (!acc[city.stateCode]) {
      acc[city.stateCode] = [];
    }
    acc[city.stateCode].push(city);
    return acc;
  }, {});

  const handleCityChange = (value) => {
    const selectedCityObjects = cities.filter((city) =>
      value.includes(`${city.stateCode}-${city.name}`)
    );
    setSelectedCities(selectedCityObjects);
  };
  return (
    <Spin spinning={loader}>
      <div className="flex-grow overflow-y-auto scrollbar-hide p-4 lg:p-6 md:p-5">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="space-y-6"
        >
          <div className="flex flex-col lg:flex-row lg:w-2/3 space-x-0 lg:space-x-10 items-center">
            <div className="w-full lg:w-1/4 h-40 flex items-center justify-center mb-4 lg:mb-0">
              {fileList?.length !== 0 ? (
                <Upload
                  action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  listType="picture-card"
                  fileList={fileList}
                  onChange={onChange}
                  onPreview={onPreview}
                >
                  {fileList?.length < 1 && uploderButton}
                </Upload>
              ) : (
                <div className="w-full h-full">
                  <CropperUploder
                    onDataFromChild={handleDataFromChild}
                    uploderButton={uploderButton}
                    identifier={"profileImage"}
                  />
                </div>
              )}
            </div>
            <div className="flex-1 space-y-3">
              <Form.Item
                name="name"
                label="Full Name"
                rules={[
                  { required: true, message: "Please input your full name!" },
                ]}
                className="text-[#4A4A4C] text-[14px] font-medium"
              >
                <Input className="h-10 text-[#4A4A4C] text-[16px] border-[#A3BBFF] " />
              </Form.Item>

              {/* <Form.Item
                name="category"
                label="Category"
                rules={[
                  {
                    required: true,
                    message: "Please select at least one category!",
                  },
                ]}
                className="text-[#4A4A4C] text-[14px] font-medium"
              >
                <Select
                  mode="multiple"
                  className="h-10 text-[#4A4A4C] text-[16px] border-[#A3BBFF] "
                >
                  {categories.map((category, index) => (
                    <Option key={index} value={category}>
                      {category}
                    </Option>
                  ))}
                </Select>
              </Form.Item> */}

              {/* <Form.Item
              name="location"
              label="Survey Location"
              rules={[
                {
                  required: true,
                  message: "Please select at least one location!",
                },
              ]}
              className="text-[#4A4A4C] text-[14px] font-medium"
            >
              <Select
                mode="multiple"
                className="h-10 text-[#4A4A4C] text-[16px] border-[#A3BBFF] "
              >
                <Option value="kerala">Kerala</Option>
                <Option value="tamilnadu">Tamil Nadu</Option>
                <Option value="karnataka">Karnataka</Option>
              </Select>
            </Form.Item> */}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 lg:w-2/3">
            <Form.Item
              name="address"
              label="Address Line"
              rules={[
                { required: true, message: "Please input your address!" },
              ]}
              className="text-[#4A4A4C] text-[14px] font-medium"
            >
              <Input className="h-10 text-[#4A4A4C] text-[16px] border-[#A3BBFF] " />
            </Form.Item>

            <Form.Item
              name="email"
              label="Email Id"
              rules={[
                { required: true, message: "Please input your email!" },
                { type: "email", message: "Please enter a valid email!" },
              ]}
              className="text-[#4A4A4C] text-[14px] font-medium"
            >
              <Input className="h-10 text-[#4A4A4C] text-[16px] border-[#A3BBFF] " />
            </Form.Item>

            {!editData && (
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                  {
                    min: 6,
                    message: "Password must be at least 6 characters long!",
                  },
                ]}
                className="text-[#4A4A4C] text-[14px] font-medium"
              >
                <Input.Password className="h-10 text-[#4A4A4C] text-[16px] border-[#A3BBFF] " />
              </Form.Item>
            )}

            <Form.Item
              name="phone"
              label="Phone Number"
              rules={[
                {
                  required: true,
                  message: "Please input your phone number!",
                },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Please enter a valid 10-digit phone number!",
                },
              ]}
              className="text-[#4A4A4C] text-[14px] font-medium"
            >
              <Input className="h-10 text-[#4A4A4C] text-[16px] border-[#A3BBFF] " />
            </Form.Item>

            <Form.Item
              name="state"
              label="State"
              rules={[
                {
                  required: true,
                  message: "Please select at least one state",
                },
              ]}
            >
              <Select
                mode="multiple"
                placeholder="Select States"
                onChange={handleStateChange}
                className="h-10 rounded-md"
                value={selectedStates.map((state) => state.isoCode)}
                filterOption={filterStates}
                onSearch={handleStateSearch}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%" }}
                maxTagCount={3}
                maxTagTextLength={10}
              >
                {states
                  .filter((state) =>
                    state.name
                      .toLowerCase()
                      .includes(stateSearchValue.toLowerCase())
                  )
                  .slice(0, 50) // Limit to first 50 matching results
                  .map((state) => (
                    <Option key={state.isoCode} value={state.isoCode}>
                      {state.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="district"
              label="district name"
              rules={[
                {
                  required: true,
                  message: "Please select at least one district",
                },
              ]}
            >
              <Select
                mode="multiple"
                placeholder="Select district"
                onChange={handleDistrictChange}
                className="h-10 rounded-md"
                disabled={selectedStates.length === 0}
                value={selectedCities.map(
                  (city) => `${city.stateCode}-${city.name}`
                )}
                filterOption={filterCities}
                onSearch={handleCitySearch}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%" }}
                maxTagCount={3}
                maxTagTextLength={10}
              >
                {Object.entries(groupedCities)
                  .filter(([stateCode, _]) =>
                    selectedStates.some((s) => s.isoCode === stateCode)
                  )
                  .map(([stateCode, stateCities]) => {
                    const stateName =
                      selectedStates.find((s) => s.isoCode === stateCode)
                        ?.name || "";
                    return (
                      <Select.OptGroup key={stateCode} label={stateName}>
                        {stateCities
                          .filter((city) =>
                            city.name
                              .toLowerCase()
                              .includes(citySearchValue?.toLowerCase())
                          )
                          .slice(0, 20) // Limit to first 20 matching results per state
                          .map((city) => (
                            <Option
                              key={`${city.stateCode}-${city.name}`}
                              value={`${city.stateCode}-${city.name}`}
                            >
                              {city.name}
                            </Option>
                          ))}
                      </Select.OptGroup>
                    );
                  })}
              </Select>
            </Form.Item>

            <Form.Item
              name="city"
              label="City"
              rules={[
                {
                  required: true,
                  message: "Please select at least one city",
                },
              ]}
            >
              <Select
                mode="multiple"
                placeholder="Select Cities"
                onChange={handleCityChange}
                className="h-10 rounded-md"
                disabled={selectedStates.length === 0}
                value={selectedCities.map(
                  (city) => `${city.stateCode}-${city.name}`
                )}
                filterOption={filterCities}
                onSearch={handleCitySearch}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%" }}
                maxTagCount={3}
                maxTagTextLength={10}
              >
                {Object.entries(groupedCities)
                  .filter(([stateCode, _]) =>
                    selectedStates.some((s) => s.isoCode === stateCode)
                  )
                  .map(([stateCode, stateCities]) => {
                    const stateName =
                      selectedStates.find((s) => s.isoCode === stateCode)
                        ?.name || "";
                    return (
                      <Select.OptGroup key={stateCode} label={stateName}>
                        {stateCities
                          .filter((city) =>
                            city.name
                              .toLowerCase()
                              .includes(citySearchValue.toLowerCase())
                          )
                          .slice(0, 20) // Limit to first 20 matching results per state
                          .map((city) => (
                            <Option
                              key={`${city.stateCode}-${city.name}`}
                              value={`${city.stateCode}-${city.name}`}
                            >
                              {city.name}
                            </Option>
                          ))}
                      </Select.OptGroup>
                    );
                  })}
              </Select>
            </Form.Item>
          </div>

          {/* ----- BANK DETAILS ---- */}

          {!editData && (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Form.Item
                name="bankName"
                label="Bank Name"
                rules={[{ required: true, message: "Please Enter Bank Name!" }]}
                className="text-[#4A4A4C] text-[14px] font-medium"
              >
                <Input
                  className="h-10 text-[#4A4A4C] text-[16px] border-[#A3BBFF] "
                  placeholder="Enter bank name"
                />
              </Form.Item>

              <Form.Item
                name="accountNumber"
                label="Account Number"
                rules={[
                  { required: true, message: "Please Enter Account Number!" },
                ]}
                className="text-[#4A4A4C] text-[14px] font-medium"
              >
                <Input
                  className="h-10 text-[#4A4A4C] text-[16px] border-[#A3BBFF] "
                  placeholder="Enter account number"
                />
              </Form.Item>
              <Form.Item
                name="accountHolderName"
                label="Account Holder Name"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Account Holder Name!",
                  },
                ]}
                className="text-[#4A4A4C] text-[14px] font-medium"
              >
                <Input
                  className="h-10 text-[#4A4A4C] text-[16px] border-[#A3BBFF] "
                  placeholder="Enter account number"
                />
              </Form.Item>

              <Form.Item
                name="ifscCode"
                label="IFSC Code"
                rules={[{ required: true, message: "Please Enter IFSC code" }]}
                className="text-[#4A4A4C] text-[14px] font-medium"
              >
                <Input
                  className="h-10 text-[#4A4A4C] text-[16px] border-[#A3BBFF] "
                  placeholder="Enter IFSC code"
                />
              </Form.Item>

              <Form.Item
                name="branchName"
                label="Branch Name"
                rules={[{ required: true, message: "Please Enter Bank Name!" }]}
                className="text-[#4A4A4C] text-[14px] font-medium"
              >
                <Input
                  className="h-10 text-[#4A4A4C] text-[16px] border-[#A3BBFF] "
                  placeholder="Enter branch name"
                />
              </Form.Item>
            </div>
          )}

          <div className="mt-6 flex flex-col md:flex-row md:space-x-4">
            <Button
              onClick={() => navigate("/surveyor-list")}
              className="w-full md:w-1/2 h-10 border font-semibold border-[#313131] text-[#313131] rounded-lg"
            >
              Discard
            </Button>
            <Button
              loading={btnLoader}
              type="primary"
              htmlType="submit"
              className="mt-4 md:mt-0 w-full md:w-1/2 h-10 text-white rounded-lg bg-[#1955EB]"
            >
              {editData ? "Update" : "Create"}
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default CreateSurveyor;
